// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton_base__Qn1yv","active":"skeleton_active__k9sfS","skeleton":"skeleton_skeleton__uenic"};